import React, { ReactNode } from 'react';
import { AccordionContent } from '../atoms/Accordion';
import cn from 'classnames';

export interface AnswerProps {
	className?: string;
	panelId: string;
	children: ReactNode;
}

const Answer = (props: AnswerProps) => {
	const { className, panelId, children } = props;
	return (
		<AccordionContent
			panelId={panelId}
			className={cn(
				'overflow-hidden text-lg text-slate-500 transition-all ease-in-out',
				className,
			)}
		>
			<div className="pb-6 lg:pb-8">{children}</div>
		</AccordionContent>
	);
};

export default Answer;
